<template>
  <div class="input" id="input">
    <input class="inputs" id="inputs" ref="input" name="" :style="{'background': (bgWhite ? '' : '#f5f7fa')}" :placeholder="params[type].placeholder" v-model="text" autocomplete="new-password" @focus="bgWhite = true" @blur="bgWhite = false" @keydown.enter.prevent="enterInput" :readonly="readonly" />
    <!-- 密码样式 -->
    <div class="password" id= "password" v-if="this.type === 'password' || this.type === 'newpassword'">
      <!-- 显示或者隐藏密码 -->
      <div class="password-icon" @click="showPasswordOrNot" :style="{marginTop: (this.type === 'password' && $route.path !== '/invite/accountexist' && $route.path !== '/invite/invitenext' ? '-42px' : '-33px')}">
        <img src="../../assets/images/new-login-2018/showpassword.png" v-show="inputType === 'text'">
        <img src="../../assets/images/new-login-2018/hidepassword.png" v-show="inputType === 'password'">
      </div>
      <!-- 记住密码 -->
      <div class="password-remember" v-show="this.type === 'password' && $route.path !== '/invite/accountexist' && $route.path !== '/invite/invitenext'" @click="rememberPassword">
        <img src="../../assets/images/new-login-2018/tickle.png" style="width: 20px;" v-show="rememberpw">
        <img src="../../assets/images/new-login-2018/no-tickle.png" style="margin-right: 4px;" v-show="!rememberpw">
        <span>remember password</span>
      </div>
      <!-- 检测密码等级 -->
      <div class="password-level" v-show="this.type === 'newpassword'">
        <div class="level" style="background: #f06f6f;" v-show="passwordLevel > 0"></div>
        <div class="level" style="background: #ffbf62;" v-show="passwordLevel > 1"></div>
        <div class="level" style="background: #4db74d;" v-show="passwordLevel > 2"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/assets/js/config'
  import translate from '../common/Translate.js'
  import { checkDevice } from '../common/Common.js'
  export default {
    data () {
      return {
        isPC: checkDevice(),
        text: this.remember ? this.remember.password : '',
        inputType: 'text',
        rememberpw: this.remember ? this.remember.rememberpw : false,
        passwordLevel: 0,
        bgWhite: false,
        autofocus: false,
        params: {
          // 账号输入
          account: {
            type: 'account',
            placeholder: translate('Your email, phone number or username')
          },
          // 密码输入
          password: {
            type: 'password',
            placeholder: translate('Your password')
          },
          // 验证码
          code: {
            type: 'code',
            placeholder: translate('Verification code')
          },
          // 新密碼輸入
          newpassword: {
            type: 'newpassword',
            placeholder: translate('New password')
          },
          // 输入姓名
          name: {
            type: 'name',
            placeholder: translate('Name')
          },
          // 输入手机号
          phone: {
            type: 'phone',
            placeholder: this.$route.query.account
          },
          // 账号不存在
          accountnotexist: {
            type: 'accountnotexist',
            placeholder: this.$route.query.account
          },
          // 账号存在
          accountexist: {
            type: 'accountexist',
            placeholder: 'Your email or phone number'
          },
          // 新邀请页账号输入
          inviteAccount: {
            type: 'inviteAccount',
            placeholder: this.$route.query.source === 'website' ? translate('Enter email, phone or username to register') : translate('input your mobile number or email here')
          }
        }
      }
    },
    props: ['type', 'remember', 'readonly', 'change'],
    mounted () {
      if (this.type === 'password' || this.type === 'newpassword') {
        this.inputType = 'password'
      }
      this.$refs.input.type = this.inputType
      // 登录页默认传入上一次输入的账号
      if (config.isLogin && (this.$route.path === '/login/signin' || this.$route.path === '/') && localStorage.getItem('passwords') && this.type === 'account') {
        if (JSON.parse(localStorage.getItem('passwords'))[0]) {
          let text = Object.keys(JSON.parse(localStorage.getItem('passwords'))[0])[0]
          if (text !== 'undefined') this.text = text
        }
      }
      // 登录页或者注册页，如果路由里带有账号参数，将该参数设为默认值
      if ((this.$route.path === '/login/signup' || this.$route.query.source === 'website') && this.$route.query.account) {
        this.text = this.$route.query.account
      }
      // 登录页面自动获取焦点
      if (this.$route.path === '/login/signin' || this.$route.path === '/' || this.$route.path === '/login/password') {
        setTimeout(() => {
          document.getElementsByClassName('inputs')[0].focus()
          // document.getElementsByClassName('inputs')[0].click()
        }, 0)
      }
      if (!this.isPC) {
        let input = document.getElementById('input')
        // mobile reset width.
        input.style.width = '100%'

        let inputs = document.getElementById('inputs')
        // reset 86% width.
        inputs.style.width = '86%'
        // element center.
        inputs.style.margin = '0 auto'
        if (this.type === 'password' || this.type === 'newpassword') {
          let password = document.getElementById('password')
          // element right 8%.
          password.style.marginRight = '8%'
        }
      }
    },
    watch: {
      text () {
        // this.bgWhite = true
        this.$emit('inputText', this.text)
        // 检测密码安全等级
        this.checkPasswordLevel()
      },
      inputType () {
        this.$refs.input.type = this.inputType
      },
      rememberpw () {
        this.$emit('rememberpw', this.rememberpw)
      },
      change () {
        this.text = this.remember.password || ''
        this.rememberpw = this.remember.rememberpw || false
      }
    },
    methods: {
      // 显示或隐藏密码
      showPasswordOrNot () {
        if (this.inputType === 'text') {
          this.inputType = 'password'
        } else {
          this.inputType = 'text'
        }
      },
      // 是否记住密码
      rememberPassword () {
        this.rememberpw = !this.rememberpw
      },
      // 检测密码安全等级
      checkPasswordLevel () {
        let strongRegex = new RegExp('^(?=.{10,})((?=.*[A-Z])|(?=.*[a-z]))(?=.*[0-9])(?=.*[!@#$%^&*()_?<>{}]).*$', 'g')
        let mediumRegex = new RegExp('^(?=.{9,})((?=.*[A-Z])|(?=.*[a-z]))(?=.*[0-9]).*$', 'g')
        let enoughRegex = new RegExp('(?=.{6,}).*', 'g')
        if (strongRegex.test(this.text)) {
          this.passwordLevel = 3
        } else if (mediumRegex.test(this.text)) {
          this.passwordLevel = 2
        } else if (enoughRegex.test(this.text)) {
          this.passwordLevel = 1
        } else {
          this.passwordLevel = 0
        }
      },
      enterInput () {
        this.$emit('enterInput')
      }
    }
  }
</script>

<style lang="scss" scoped>
	.input {
    width: 300px;
    height: 40px;
    margin: 0 auto;
    margin-top: 30px;
    input {
      width: 100%;
      height: 40px;
      display: inherit;
      padding: 10px;
      // background: #f5f7fa;
      border: 1px solid #eeeeee;
      border-radius: 2px;
      outline: none;
    }
    .password {
      .password-icon {
        width: 24px;
        height: 24px;
        float: right;
        margin-right: 10px;
        // position: absolute;
        // right: 50px;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
        }
      }
      .password-remember {
        width: 100%;
        height: 16px;
        line-height: 16px;
        margin: 0 auto;
        margin-top: 10px;
        cursor: pointer;
        img {
          width: 16px;
          height: 16px;
          float: left;
        }
        span {
          color: #939699;
          margin-left: 7px;
          float: left;
          -webkit-user-select: none;
          user-select: none;
        }
      }
      .password-level {
        width: 100%;
        height: 4px;
        margin-top: 4px;
        .level {
          width: 96px;
          height: 4px;
          float: left;
          border-radius: 1px;
          margin-right: 6px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Inputs.vue?7f7cb096